var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_8116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.553 28.9119C107.561 17.8971 96.1051 6.43922 85.0881 3.44672C78.3327 1.76344 69.2839 0.0289453 57 0C44.7161 0.0289453 35.6673 1.76344 28.9119 3.44672C17.8971 6.43922 6.43922 17.8949 3.44672 28.9119C1.76344 35.6673 0.0289453 44.7161 0 57C0.0289453 69.2839 1.76344 78.3327 3.44672 85.0881C6.43922 96.1051 17.8971 107.561 28.9119 110.553C35.6673 112.237 44.7205 113.971 57 114C69.2817 113.971 78.3327 112.237 85.0881 110.553C96.1051 107.561 107.561 96.1051 110.553 85.0881C112.237 78.3327 113.971 69.2795 114 57C113.971 44.7161 112.237 35.6673 110.553 28.9119Z",
    fill: "#E5F4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 19.1484C49.5137 19.1484 42.1955 21.3684 35.9708 25.5276C29.7462 29.6868 24.8946 35.5984 22.0297 42.5148C19.1648 49.4313 18.4153 57.042 19.8758 64.3845C21.3363 71.727 24.9413 78.4715 30.2349 83.7651C35.5286 89.0587 42.2731 92.6637 49.6155 94.1243C56.958 95.5848 64.5687 94.8352 71.4852 91.9703C78.4017 89.1054 84.3133 84.2539 88.4724 78.0292C92.6316 71.8045 94.8516 64.4863 94.8516 57C94.8516 46.9611 90.8637 37.3334 83.7651 30.2349C76.6666 23.1364 67.0389 19.1484 57 19.1484Z",
    fill: "url(#paint0_linear_33_8116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5979 50.7322L55.8357 74.6277C55.2158 75.2786 54.471 75.7976 53.6457 76.1538C52.8205 76.51 51.9318 76.696 51.033 76.7006H51.0041C50.1105 76.7006 49.226 76.5212 48.4029 76.1732C47.5799 75.8251 46.835 75.3155 46.2125 74.6744L34.1379 62.2346C33.4812 61.616 32.9567 60.8708 32.5959 60.0439C32.2351 59.217 32.0456 58.3256 32.0388 57.4234C32.0319 56.5213 32.2079 55.6271 32.5561 54.7948C32.9042 53.9625 33.4174 53.2094 34.0646 52.5809C34.7118 51.9524 35.4796 51.4615 36.3217 51.1378C37.1638 50.8141 38.0628 50.6643 38.9643 50.6976C39.8659 50.7308 40.7514 50.9463 41.5673 51.3311C42.3833 51.7159 43.1129 52.262 43.7121 52.9365L50.9484 60.3933L68.9145 41.5254C69.5191 40.8896 70.2429 40.379 71.0447 40.023C71.8466 39.6669 72.7107 39.4722 73.5877 39.4501C74.4648 39.428 75.3376 39.5788 76.1564 39.894C76.9751 40.2092 77.7238 40.6826 78.3596 41.2871C78.9954 41.8917 79.506 42.6155 79.862 43.4173C80.2181 44.2192 80.4128 45.0833 80.4349 45.9603C80.457 46.8374 80.3062 47.7102 79.991 48.529C79.6758 49.3477 79.2024 50.0964 78.5979 50.7322Z",
    fill: "url(#paint1_linear_33_8116)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_8116",
    x1: 83.77,
    y1: 83.77,
    x2: 30.2301,
    y2: 30.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_8116",
    x1: 67.3849,
    y1: 63.083,
    x2: 45.6893,
    y2: 41.3851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_8116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.b8382a853a678507a66828345a179897.svg";
export { ForwardRef as ReactComponent };